export default function ErrorMessage ({ message }) {
    return <div className="text-red-700 bg-red-100 p-3">
        {message}
    </div>
}